<template>
  <div v-loading='loading' class='gPageBorder'>

              <el-form ref="addForm" id="addForm" :model="form" :rules="rules" label-width="12.5%" class="gForm">

                <el-form-item :label="$t('app_name')" prop="name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>

                <el-form-item :label="$t('terminal.appBind.label_version')" prop="version" v-show="fwVersionInputVisable">
                  <el-input v-model="form.version"></el-input>

                  <div style="color: #8391a5;font-size:12px;line-height: 2;margin-top: 4px;">{{$t('lin_global.verTips1')}}</div>
                </el-form-item>


                <el-form-item :label="$t('app_fwType')" prop="type">
                    <el-select style='' v-model="form.type" clearable :placeholder="typeHolder" @change='selectTypeChange'>
                    <el-option
                      v-for="item in $firmwareTypes"
                      :key="item.vl"
                      :label="item.label"
                      :value="item.vl">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('app_distributor')" prop="mechanism">
                    <!--<el-select style='' v-model="form.mechanism" clearable :placeholder="$t('app_select')">-->
                    <!--<el-option-->
                      <!--v-for="item in mechs"-->
                      <!--:key="item.mechanismid"-->
                      <!--:label="item.mechanismname"-->
                      <!--:value="item.mechanismid">-->
                    <!--</el-option>-->
                  <!--</el-select>-->
                  <MechanismSelector v-if="mechanismData" :data="mechanismData" :mselect="true" :classs="'w_33'"></MechanismSelector>
                </el-form-item>

        <el-form-item :label="$t('app_chooseFile')" prop="url">
           <!-- upload -->
           <el-upload
            class="upload-demo aeMg"
            drag
            accept=''
            name='fileUpload'
            :file-list="fileList"
            :on-success="fileUploadSuccess"
            :before-upload="fileBeforeUpload"
            :action="fileUploadUrl">
            <span v-if='fileList.length > 0'>
              <div style='margin-top:50px;'><i style='color:#13CE66' class="el-icon-check"></i></div>
              <div class="el-upload__text">{{$t('app_ulSuccess')}}</div>
            </span>

            <span v-else>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">{{$t('app_ulNormalSt')}}</div>
            </span>
          </el-upload>
        </el-form-item>


                <el-form-item>
                  <el-button type="primary" @click="onSubmit">{{$t('app_submit')}}</el-button>
                </el-form-item>

              </el-form>


  </div>

</template>

<script>
  var vCheck = (rule, value, callback) => {
    /*if (!value) {
      if (window.self.form.type === 'KOS' || window.self.form.type === 'KSP') {
        //alert('')
        callback(new Error(window.self.$t('noVerTag')));
      } else {
        callback()
      }
    } else {
      callback()
    }*/
    if (window.self.form.type !== 'KOS' && window.self.form.type !== 'KSP' && window.self.form.type !== 'HEX') {
      callback()
    }
    var arr = value.split('.')
    if (arr.length > 1) {
      var illegal = false
      arr.forEach((vl)=> {
        var patt1=new RegExp("^[1-9]\d*|0$");
        illegal = !patt1.test(vl)
      })
      if (illegal) {
        callback(new Error(window.self.$t('app_fmVerIillegal')));
      } else {
        callback()
      }
    } else {
      callback(new Error(window.self.$t('app_fmVerIillegal')));
    }
      //callback()
   
  }
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    components: {
      MechanismSelector
    },
    data (){
      var versionCheck = (rule, value, callback) => {

				if (this.udFileType == 0 && rule.field == 'preVersion') {
					callback();
					return
				}

        var rg = /^\d+(\.\d+)+$/;
        if(!(rg.test(value))){
          callback(new Error(this.$t('lin_global.bbhgsbd')));
        }else{
          callback();
				}
				
      };
      var that = this
      return{
        mechanismData: null,
        editInfo: '',
        mechs: [],
        loading: 0,
        fileList: [],
        form:{
          name:'',
          version:'',
          type:'',
          url:'',
          md5: '',
          mechanism: {
            id: '',
            name: ''
          }
        },
        rules:{
          'name':[{
            required: true,
                  message: this.$t('lin_global.notBlankName')
          }],
          'version':[{
						required:  true,
		        message: this.$t('lin_global.notBlankVer')
					},{
            validator: versionCheck, trigger: 'blur'
					}],
          'type':[{
            required: true,
                  message: this.$t('lin_global.qxzlx')
          }],
          'mechanism':[{
            required: true,
                  message: this.$t('app_selectChannel')
          }],
          'url':[{
            required: true,
                  message: this.$t('lin_global.qxzscwj')
          }]
        },
        areaList:[],
        fwVersionInputVisable: true
      }
    },
    mounted(){
      window.self = this
      var that = this
      var mVl = ''
      if (!this.isUpload()) {
        var obj = this.$getWObj().info
        if (obj) {
          this.editInfo = obj
          this.fillData()
        }
        mVl = obj.mechanismId
      }
      this.mechanismData = {
        value: mVl,
        placeholder: this.$t('lin_global.place_areaid'),
        optValue: true,
        callback (value) {
          console.log(value)
          that.form.mechanism = value
        }
      }
    },
    computed: {
      fileUploadUrl () {
        // return this.$fileUploadUrl
        return this.$urls.fileUrl
      },
      typeHolder () {
        if (this.isUpload()) {
          return this.$t('app_select')
        } else {
          return ''
        }

      }
    },
    methods:{
      isVer () {
        if (!this.form) return false
        if (this.form.type == 'HEX' || this.form.type == 'KSP' || this.form.type == 'KOS') {
          return true
        } else {
          return false
        }
      },
      isUpload () {
        return this.$route.path === '/firmwareManage/upload'
      },
      fillData () {
        console.log(this.editInfo)
        this.form.name = this.editInfo.firmwareName
        this.form.version = this.editInfo.version
        this.form.type = this.editInfo.type
        this.form.mechanism.id = this.editInfo.mechanismId
        this.form.mechanism.name = this.editInfo.mechanismName
        this.form.url = this.editInfo.url
        this.fileList = [{name: this.editInfo.firmwareName}]
        var _this = this
      },
      hBlur (name) {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
          } else {
            return false
          }
        })
      },
      fileUploadSuccess (res, file) {
        window[this.$route.path] = ''
        // console.log('file', res)
        if (res.status === 200) {
          this.form.url = res.fileUrl
          // this.form.verTag = res.versionCode
          // this.form.version = res.appVersion
          // this.form.packageName = res.packageName
          // this.fileSize = res.appSize
          this.form.md5 = res.md5
          this.fileList = [{name: file.name}]
          this.hBlur()
        } else {
          if (this.config.type !== 1) {
            this.fileList = []
          } else {
            this.fileList = [{name: file.name}]
          }
          this.$message.error(this.$t('app_onlyApk'))
        }
      },
      fileBeforeUpload (file) {
        console.log(file)
        window[this.$route.path] = 1
        return 1
        /* if (file) {
          var ar = file.name.split('.')
          var type = ar[ar.length - 1]
          if (type === 'apk') {
            var limit = 500000 // k单位
            if (file.size / 1000 > limit) {
              this.$message.error(this.$t('app_fileOver') + '500M')
              return false
            }
            window[this.$route.path] = 1
            return true
          } else {
            this.$message.error(this.$t('app_onlyApk'))
            return false
          }
        } else {
          this.$message.error(this.$t('app_onlyApk'))
          return false
        } */
      },
      onSubmit:function(){
        this.$refs['addForm'].validate((valid) => {
          if (!this.isVer()) {
            this.form.version = '1.0'
          }
          
          if (valid) {
            this.loading = 1
            var isUpload = !this.editInfo
            if (isUpload) {
               console.log(this.form.url)

              this.$uploadFirmware(this.form.md5, this.form.mechanism.name, this.form.mechanism.id,this.form.name, this.form.type, this.form.url, this.form.version, (res) => {
                // console.log(res)
                this.loading = 0
                if (res.status === 200) {
                  this.$message.success(res.message)
                  this.$router.go(-1)
                } else {
                  this.$message(res.message)
                }
              }, () => {
                this.loading = 0
                this.$message(this.$t('app_rqsError'))
              })
            } else {
              this.loading = 0
              console.log("firmware param: " + this.form)
              this.$editFirmware(this.form.md5, this.editInfo.id, this.form.name, this.form.url, this.form.version, this.form.type, this.form.mechanism.id, this.form.mechanism.name, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.$router.go(-1)
                  this.$message.success(res.message)
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            }
          } else {
            return false
          }
        })
      },
      onCancel:function(){
        this.$router.go(-1);
      },
      // add by sing, 2017-08-04
      // 非KSP和KOS类型，隐藏版本号输入框
      selectTypeChange: function (value) {
          if (value === 'KSP' || value === 'KOS' || value === 'HEX') {
              this.fwVersionInputVisable = true
          } else {
            this.form.version = ''
            this.fwVersionInputVisable = false
          }
          console.log('select value: ' + value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?21bc9edc